
import _ from 'lodash';

const getTagTypeBasedOnStatus = (state) => (statusCode)=>{
  if(statusCode==="DRAFT"){
    return "info"
  }else if(statusCode=="ISSUED"){
    return ""
  }else if(statusCode=="CANCELLED"){
    return "danger"
  }else  if(statusCode=="RECEIVED"){
    return "success"
  }else if (statusCode=="PARTIAL_RECEIVED"){
    return "warning"
  }else if (statusCode=="IN_CORRECTION"){
    return "warning"
  }else{
    return "";
  }
}

const vendorName = (state) => {
  if(state.selectedPurchaseOrder!=null && state.selectedPurchaseOrder.vendor!=null){
    return (state.selectedPurchaseOrder.vendor.usual_name!=null&&state.selectedPurchaseOrder.vendor.usual_name!='')?state.selectedPurchaseOrder.vendor.usual_name:state.selectedPurchaseOrder.vendor.name;
  }else{
    return null;
  }
}

const is_in_correction = (state) => {
  let is_in_correction = false;
  if (state.selectedPurchaseOrder != null) {
    _.forEach(state.selectedPurchaseOrder.lines, line=>{
      if(line.in_correction)is_in_correction=true;
    })
  }
  return is_in_correction;
}

const is_line_in_correction = (state) => (indexLine) =>{
  if(state.selectedPurchaseOrder==null) return false;
  return state.selectedPurchaseOrder.lines[indexLine].in_correction;
}

const canShowCorrectionComponent = (state) => (indexLine) => {
  //On affiche le composante si le statut est après confirmé.
  let show = false;
  if (_.get(state.selectedPurchaseOrder, 'inventory.code') !== 'IP'){
    return false;
  }
  if(state.selectedPurchaseOrder==null) return show;
  if(state.selectedPurchaseOrder.status.code=="CONFIRMED" ||
     state.selectedPurchaseOrder.status.code=="PARTIAL_RECEIVED" ||
     state.selectedPurchaseOrder.status.code=="IN_CORRECTION"){
       return state.selectedPurchaseOrder.lines[indexLine].purchase_status.qty_received<state.selectedPurchaseOrder.lines[indexLine].purchase_status.qty_ordered;
     }
   return show;
}
// const is_line_complte = (state) => (indexLine) =>{
//   if(state.selectedPurchaseOrder==null) return false;
//   return state.selectedPurchaseOrder.lines[indexLine].purchase_status.qty_;
// }

const isFiltered = (state) =>{
  return !(state.filters.status.length == 0 &&
          state.filters.date==null &&
          state.filters.year==null &&
          state.filters.availabilityDate==null &&
          state.filters.availabilityYear==null &&
          (state.searchTerms==null || state.searchTerms==''))

}

export default {
  getTagTypeBasedOnStatus,
  vendorName,
  is_in_correction,
  is_line_in_correction,
  canShowCorrectionComponent,
  isFiltered
};
